/**
* @license Apache-2.0
*
* Copyright (c) 2025 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* Number of significand bits for a single-precision floating-point number.
*
* @module @stdlib/constants-float32-num-significand-bits
* @type {integer32}
*
* @example
* var FLOAT32_NUM_SIGNIFICAND_BITS = require( '@stdlib/constants-float32-num-significand-bits' );
* // returns 23
*/


// MAIN //

/**
* Number of significand bits for a single-precision floating-point number.
*
* @constant
* @type {integer32}
* @default 23
*/
var FLOAT32_NUM_SIGNIFICAND_BITS = 23|0;


// EXPORTS //

module.exports = FLOAT32_NUM_SIGNIFICAND_BITS;
